module.exports = __webpack_public_path__ + "static/media/campus-upsell-popup.bdb2b057.mp3";